<template>
  <div class="app-container">
    <el-container>
      <div style="border: 1px solid #eee">
        <el-row>
          <el-col style="margin-top: 10px; margin-left: 10px">
            <el-date-picker
              v-model="time"
              @change="dateChange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>

            <el-button type="primary" style="margin-left: 20px" @click="getList"
              >查询</el-button
            >
          </el-col>
        </el-row>

        <el-row>
          <el-table
            v-loading="listLoading"
            :data="list"
            height="400px"
            border
            fit
            highlight-current-row
            style="width: 100%; margin-top: 20px"
          >
            <el-table-column width="200px" align="center" label="时间">
              <template slot-scope="scope">
                <span>{{ convertTime(scope.row.reportTime) }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200px" align="center" label="报告">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>

            <el-table-column width="200px" align="center" label="编号">
              <template slot-scope="scope">
                <span>{{ scope.row.reportCode }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150px" align="center" label="状态">
              <template slot-scope="scope">
                <span>{{ getLabReportStatus(scope.row.status) }}</span>
              </template>
            </el-table-column>

            <el-table-column width="150px" align="center" label="类型">
              <template slot-scope="scope">
                <span>{{ getLabReportType(scope.row.reportType) }}</span>
              </template>
            </el-table-column>

            <el-table-column align="center" fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  style="margin-left: 0px; align-self: center"
                  type="text"
                  @click="getItemDetail(scope.row)"
                >
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.pageNum"
            :limit.sync="listQuery.pageSize"
            @pagination="getList"
          />

          <lab-detail
            v-if="labReportDetailVisible"
            ref="LabReportDetailRef"
          ></lab-detail>
        </el-row>
      </div>
    </el-container>
  </div>
</template>

<script>
import { getLabInfos, turnToPageLabInfos } from "@/api/health/LabQuery";
import moment from "moment";
import Pagination from "@/components/Pagination";
import labDetail from "./labDetail.vue";

export default {
  components: { Pagination, labDetail },
  props: {
    pInfo: null,
  },
  data() {
    return {
      labReportDetailVisible: false,
      total: 0,
      listLoading: false,
      list: null,
      listQuery: {
        idcard: "",
        startTime: null,
        endTime: null,
        pageNum: 1,
        pageSize: 10,
      },
      detailQuery: {
        patientId: "",
        id: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      time: [],
    };
  },
  created() {
    if (this.listQuery.startTime == null) {
      this.listQuery.startTime = this.getDate(-365);
      this.listQuery.endTime = this.getDate(1);
    }
    this.time.push(this.listQuery.startTime);
    this.time.push(this.listQuery.endTime);
    this.getList();
  },
  methods: {
    //   getPageNum(){
    //     var num =  parseInt(this.listQuery.pageNum) +1;
    //     return num;
    //   },
    dateChange() {
      this.listQuery.startTime = this.time[0];
      this.listQuery.endTime = this.time[1];
    },
    getList() {
      this.listQuery.idcard = this.pInfo.idcard;

      let data = Object.assign({}, this.listQuery, {
        pageNum: this.listQuery.pageNum - 1
      })

      // let data = Object.assign({}, this.listQuery, {
      //   pageNum: this.listQuery.pageNum
      // })

      console.log("检验data:",data);

      this.listLoading = true;
      
      getLabInfos(data).then((response) => {
        this.list = response.contents;
        this.total = response.totalRecords;
        // console.log(response);
        // this.listQuery.pageNum = response.pageNum-2;

        this.listLoading = false;
      });
    },
    turnToPage(){
      turnToPageLabInfos(this.listQuery).then((response) => {
        this.list = response.contents;
        this.total = response.totalRecords;
      });
    },
    getItemDetail(row) {
      // console.log(row);
      this.labReportDetailVisible = true;
      this.$nextTick(() => {
        this.$refs.LabReportDetailRef.init(row);
      });
    },
    getLabReportStatus(item) {
      if (item == "F") {
        return "审核报告";
      } else if (item == "P") {
        return "初步结果";
      }

      return "";
    },
    getLabReportType(item) {
      if (item == "N") {
        return "普通";
      } else if (item == "M") {
        return "微生物";
      } else if (item == "T") {
        return "描述类报告";
      }

      return "";
    },
    getDate(day) {
      const now = new Date();
      const monthn = now.getMonth();
      const yearn = now.getFullYear();
      const daten = now.getDate() + day;
      var time = new Date();
      time.setFullYear(yearn, monthn, daten);
      time.setHours(0, 0, 0);

      var formatTime = time.Format("yyyy-MM-ddThh:mm:ss.SZ"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
      // var formatTime = moment(time).format("YYYY-MM-DD HH:mm");
      // var formatTime = moment(time).format("yyyy-MM-ddThh:mm:ss.SZ");
      return formatTime;
    },
    convertTime(row) {
      // var dt = Date.parse(row);
      // var str = moment(new Date(parseInt(dt))).format("YYYY-MM-DD hh:mm:ss");
      var str = moment(row).format("YYYY-MM-DD HH:mm");
      return str;
    },
  },
};
</script>

<style>
</style>
